import { getHireJobsCandidatesTryoutShiftsRetrieveQueryOptions } from "@sidegigllc/api/client";
import { applicantQuery, jobQuery, managersQuery } from "domains/hire/containers/ApplicantSheetContainer/queries";
import type { WarmableQuery } from "routing/warmQueries";

type QueriesInput = { jobId: string; locationId: number; applicantIds: Array<string> };

export const queries = ({ jobId, locationId, applicantIds }: QueriesInput): Array<WarmableQuery> => [
  jobQuery({ jobId }),
  managersQuery({ locationId }),
  ...applicantIds.map((applicantId) => applicantQuery({ jobId, applicantId })),
];

/** Behind the `tryout-shifts` flag (404 when off), so it is read on demand and not warmed by `queries`. */
export const tryoutShiftsQuery = ({ jobId, applicantId }: { jobId: string; applicantId: string }) =>
  getHireJobsCandidatesTryoutShiftsRetrieveQueryOptions(jobId, applicantId);
